import Image from "next/image";

const SingleFilePreview = ({ imgUrl }) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full p-1">
      <Image
        alt="file preview"
        height={20}
        width={20}
        src={imgUrl}
        className="w-full h-full rounded"
      />
    </div>
  );
};

export default SingleFilePreview;
